import React from 'react'
import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useSurveyMutation = () => {
  return useGenericRequestHandler({
    route: 'v1/i/survey',
    method: 'POST'
  })
}
